import { useAuthFlow, useLogout } from "students-api"
import { createFileRoute, useParams, useRouter } from "@tanstack/react-router"
import { useEffect } from "react"
import { LoginWrapper } from "toptaal-shared"

export const Route = createFileRoute("/login/$token")({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const { logout } = useLogout()

  const { token } = useParams({ from: "/login/$token" })

  useEffect(() => {
    // Clear auth store on login
    logout()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { statusMessage, isError } = useAuthFlow({
    token,
    type: "login",
    onSuccess: () => {
      router.navigate({ to: "/", replace: true })
    },
    onMissingToken: () => {
      router.navigate({ to: "/login" })
    },
  })

  return (
    <LoginWrapper
      title="Inloggen"
      onBackToLogin={
        isError ? () => router.navigate({ to: "/login" }) : undefined
      }
    >
      <p className="text-center">{statusMessage}</p>
    </LoginWrapper>
  )
}
